import translations from './translations.json';

export const numberFormats = {
  'fr-FR': {
    currency: {
      style: 'currency',
      currency: 'EUR',
    }
  }
}

export const dateTimeFormats = {
  'fr-FR': {
    time: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    shortWithTime: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }
  }
};

export default {
  ...translations
}
